import React from 'react';
import { Grid } from '@mui/material';
import { Add, ArrowDropDown } from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import AvatarGroupComp from './AvatarGroupComp';
import Theme from '../ui/Theme';

const SelectInstructorField = ({ personText, personImage = [], assignInstructorFn, openAddSourcePopup, classes }) => (
  <Grid container direction="row" justifyContent="flex-start" alignItems="center">
    <Grid
      item
      style={{
        padding: '6px',
        width: '85%',
        background: 'white',
        border: '1px solid rgba(228, 231, 236, 1)',
      }}
      onClick={assignInstructorFn}
    >
      <Grid container justifyContent="space-between" alignItems="center" className={classes.resize3}>
        <Grid item>
          {personText ? (
            <AvatarGroupComp pro={personImage} txt={personText} sub="Instructors in this story" />
          ) : (
            <Typography style={{ font: 'Lato', fontSize: '12px', fontWeight: 500 }}>No Instructors yet</Typography>
          )}
        </Grid>
        <Grid item>
          <ArrowDropDown />
        </Grid>
      </Grid>
    </Grid>
    <Grid item style={{ background: Theme.palette.primary.main }}>
      <Add style={{ width: '32px', height: '32px', color: 'white' }} onClick={openAddSourcePopup} />
    </Grid>
  </Grid>
);

export default SelectInstructorField;
